'use strict';
module.exports = require('./TreeTable.vue');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/treetable/index.js
// module id = 68
// module chunks = 1